'use client';
import AppLayout from '@/components/AppLayout';
import BillingDashboardClient from './components/BillingDashboardClient';

export default function BillingDashboardPage() {
  return (
    <AppLayout>
      <BillingDashboardClient />
    </AppLayout>
  );
}
